@if (form) {
  <form class="astral-dialog-form astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()">
    <h4>{{ 'RENTAL_OBJECT_CATEGORY.TITLE' | translate }}</h4>
    <astral-select [control]="form.controls['category']" [itemsSource]="categories"></astral-select>
    <astral-select [control]="form.controls['rentalObjectTypeId']" [itemsSource]="rentalObjectTypes"></astral-select>
    @if (showBuilding) {
      <astral-select [control]="form.controls['buildingId']" [itemsSource]="buildings"></astral-select>
    }
    @if (showEntrance) {
      <astral-select [control]="form.controls['entranceId']" [itemsSource]="entrances"></astral-select>
    }
    @if (missingArticles.length) {
      <div>
        <app-information-block
          [mode]="'bubble'"
          [status]="'error'"
          [text]="'RENTAL_OBJECT_CATEGORY.MISSING_ARTICLES' | translate"
        ></app-information-block>
        <ul class="missing-articles">
          @for (article of missingArticles; track article.vatPercent + '-' + article.adjustment + '-' + article.category) {
            <li class="missing-articles__item">
            <strong>{{ categoryTranslation(article.category) | translate }}</strong>
            <div>{{ 'RENTAL_OBJECT_CATEGORY.VAT_PERCENT' | translate }}: {{ article.vatPercent }} %</div>
            <div>
              {{ 'RENTAL_OBJECT_CATEGORY.ADJUSTMENT' | translate }}:
              {{ adjustmentTranslation(article.adjustment) | translate }}
            </div>
            </li>
          }
        </ul>
      </div>
    }
    <div class="astral-form-actions">
      <astral-button variant="primary" type="submit" labelKey="SAVE_BTN" [disabled]="working"></astral-button>
      <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
    </div>
  </form>
}
